import InfoRounded from '@mui/icons-material/InfoRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { ProviderData } from '@openx/types/provider';
import { useTranslation } from 'react-i18next';
import { getProvidersLabels, providerFields } from '../../constants';

type AllowedOrganizationsSectionProps = {
  allowedAccounts: ProviderData['allowed_accounts'];
};

export const AllowedOrganizationsSection = ({ allowedAccounts }: AllowedOrganizationsSectionProps) => {
  const { t } = useTranslation();
  const providersLabels = getProvidersLabels(t);

  return (
    <FormSection divider title={t('Allowed Organizations')}>
      {allowedAccounts.length === 0 ? (
        <Box sx={{ alignItems: 'center', display: 'flex' }}>
          <InfoRounded sx={{ color: 'text.secondary', mr: 1 }} />
          <Typography data-test="no-linked-accounts-message">
            {t('No Organization(s) linked to this provider.')}
          </Typography>
        </Box>
      ) : (
        <>
          <Typography sx={{ color: 'text.secondary', mb: 1 }}>
            {providersLabels[providerFields.ALLOWED_ACCOUNTS]}
          </Typography>

          {allowedAccounts.map(({ account }, index) => (
            <Typography key={`${index}-${account.name}`} data-test="allowed-account-value">
              {account.name}
            </Typography>
          ))}
        </>
      )}
    </FormSection>
  );
};
